import React from "react";
import ReactDOM from "react-dom";

import Timeline from "./Timeline";

const timelineContainer = document.querySelector("[data-timeline-container]");
if (timelineContainer) {
  ReactDOM.render(<Timeline />, timelineContainer);
}
